var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.options.image)?_c('img',{attrs:{"src":_vm.$i18n.locale + '/images/' + _vm.options.image}}):_vm._e(),_c('span',{staticClass:"chapter-title",domProps:{"innerHTML":_vm._s(_vm.options.chapterTitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }